module.exports = __webpack_public_path__ + "static/media/lobster.e0b89e6c.png";